export const numberToCurrency = (number: string | number) => {
	return Number(number).toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
		maximumFractionDigits: 0
	})
}
